import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Grid, Text } from '@chakra-ui/react';
import { formatDataTestId } from '@whitbread-eos/utils';
import { Fragment } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DetailsPanel(_ref) {
  var _data$rows;
  var data = _ref.data,
    stylesObject = _ref.stylesObject;
  var baseDataTestId = 'BookingDetailsTable';
  return _jsxs(Box, _objectSpread(_objectSpread({}, stylesObject === null || stylesObject === void 0 ? void 0 : stylesObject.wrapper), {}, {
    "data-testid": formatDataTestId(baseDataTestId, 'Container'),
    children: [_jsx(Text, _objectSpread(_objectSpread({}, stylesObject === null || stylesObject === void 0 ? void 0 : stylesObject.title), {}, {
      "data-testid": data === null || data === void 0 ? void 0 : data.title,
      children: data === null || data === void 0 ? void 0 : data.title
    })), _jsx(Grid, {
      templateColumns: "1fr 2fr",
      gap: 2,
      children: data === null || data === void 0 || (_data$rows = data.rows) === null || _data$rows === void 0 ? void 0 : _data$rows.map(row => {
        return _jsxs(Fragment, {
          children: [_jsx(Text, _objectSpread(_objectSpread({}, stylesObject === null || stylesObject === void 0 ? void 0 : stylesObject.rowKey), {}, {
            "data-testid": row.key,
            children: row.key
          })), _jsx(Text, _objectSpread(_objectSpread({}, stylesObject === null || stylesObject === void 0 ? void 0 : stylesObject.rowValue), {}, {
            children: row.value
          }))]
        }, "row-".concat(row.key));
      })
    })]
  }));
}